import { dateHelpers } from '@nocowanie/core/helpers';

import { SearchEngineModel } from '../models';

export const generateSearchCriteriaParamsFromCookie = (
    criteria: Partial<SearchEngineModel>,
): string => {
    const { guests, dates, flexDates } = criteria;
    const params = new URLSearchParams();

    if (dates?.checkInDate) {
        params.set('checkInDate', dateHelpers.format(dates.checkInDate, 'yyyy-MM-dd'));
    }

    if (dates?.checkOutDate) {
        params.set('checkOutDate', dateHelpers.format(dates.checkOutDate, 'yyyy-MM-dd'));
    }

    if (flexDates) {
        params.set('flexDates', flexDates.toString());
    }

    if (guests?.adultsCount) {
        params.set('adultsCount', guests.adultsCount.toString());
    }

    if (guests?.childrenCount) {
        params.set('childrenCount', guests.childrenCount.toString());
    }

    if (guests?.childrenAges && guests.childrenAges.length > 0) {
        guests.childrenAges.forEach((age, index) => {
            params.set(`childrenAges[${index}]`, age.toString());
        });
    }

    return params.toString();
};

export const appendSearchCriteriaParamsToPath = (
    path: string,
    criteria?: Partial<SearchEngineModel> | null,
): string => {
    if (!criteria) {
        return path;
    }

    const queryString = generateSearchCriteriaParamsFromCookie(criteria);

    if (!queryString) {
        return path;
    }

    const separator = path.includes('?') ? '&' : '?';

    return `${path}${separator}${queryString}`;
};
